import * as fromFDCActions from '../../actions/Componentes/fichaPD.actions';


export interface FichaPDState {
    fichaActiva: string;
}

const initialStateRedAgua: FichaPDState = {
    fichaActiva: 'Cartografia'
};

export function fichaPDReducer(state = initialStateRedAgua, action: fromFDCActions.FichaPDActions): FichaPDState {
    switch (action.type) {
        case fromFDCActions.ACTIVARPDFICHA:
            return {
                ...state,
                fichaActiva: action.ficha
            };
      default: {
        return state;
      }
    }
}
